export { default as get } from 'lodash/fp/get'
export { default as groupBy } from 'lodash/fp/groupBy'
export { default as has } from 'lodash/fp/has'
export { default as isEmpty } from 'lodash/fp/isEmpty'
export { default as isEqual } from 'lodash/fp/isEqual'
export { default as map } from 'lodash/fp/map'
export { default as mapValues } from 'lodash/fp/mapValues'
export { default as merge } from 'lodash/fp/merge'
export { default as omit } from 'lodash/fp/omit'
export { default as omitBy } from 'lodash/fp/omitBy'
export { default as pick } from 'lodash/fp/pick'
export { default as pickBy } from 'lodash/fp/pickBy'
export { default as set } from 'lodash/fp/set'
export { default as sumBy } from 'lodash/fp/sumBy'
export { default as toPlainObject } from 'lodash/toPlainObject'
export { uniq, uniqBy } from './src/uniq'
export { default as update } from 'lodash/fp/update'
export { chunk } from './src/chunk'
export { keyBy } from './src/keyBy'

export const isFunction = (f: unknown): f is Function =>
  typeof f === 'function'
export const isNull = (o: unknown): o is null => o === null

export const isUndefined = (o: unknown): o is undefined =>
  typeof o === 'undefined'

export const isString = (s: unknown): s is string =>
  typeof s === 'string'

export const isWithLength = <T extends { length: number }>(
  s: T
): s is T => s.length > 0

export const isUuid = (s: unknown): s is string =>
  typeof s === 'string' && (s.length === 32 || s.length === 36)

/*!
 * Check if an item is a plain object or not
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}  obj  The item to check
 * @return {Boolean}      Returns true if the item is a plain object
 */
export function isPlainObject(obj: unknown): obj is object {
  return (
    Object.prototype.toString.call(obj) === '[object Object]'
  )
}
